import { render, staticRenderFns } from "./PushTextVariants.vue?vue&type=template&id=d8e3c5a6&scoped=true&"
import script from "./PushTextVariants.vue?vue&type=script&lang=js&"
export * from "./PushTextVariants.vue?vue&type=script&lang=js&"
import style0 from "./PushTextVariants.vue?vue&type=style&index=0&id=d8e3c5a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8e3c5a6",
  null
  
)

export default component.exports